import React, { useState, Context, ReactElement, Component } from "react";

export interface ingress_type {
    kind: string;
    items: ingress_type_item[];
}

export interface rule_type_item {
    key: string | number;
    host: string;
    external: string | undefined;
    http: { paths: path_type_item[] };
}

export interface path_type_item {
    path: string;
    backend: {
        serviceName: string;
        servicePort: string;
    }
}

export interface ip_type_item {
    ip: string;
}

export interface event_type_item {
    metadata: {
        name: string;
        namespace: string;
        uid: string;
        creationTimestamp: string;
    };
    reason?: string;
    note?: string;
    type: string;
    object: string;
}

export interface ingress_type_item {
    metadata: {
        name: string;
        namespace: string;
        selfLink: string;
        uid: string;
        resourceVersion: string;
        generation: number;
        creationTimestamp: string;
        labels?: object;
        annotations?: object;
    };

    spec: {
        rules: rule_type_item[];
        rules_new: rule_type_item[];    //处理后的rules
        finalizers?: string[];
        description?: string;
    };
    status?: {
        phase: string;
        loadBalancer: { ingress: ip_type_item[] };
    };
}

const IngressContext: Context<[ingress_type_item[] | undefined, React.Dispatch<React.SetStateAction<ingress_type_item[] | undefined>>]> = React.createContext<[ingress_type_item[] | undefined, React.Dispatch<React.SetStateAction<ingress_type_item[] | undefined>>]>([undefined, (_value: any) => { }]);

const IngressProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [ingress, set_ingress]: [ingress_type_item[] | undefined, React.Dispatch<React.SetStateAction<ingress_type_item[] | undefined>>] = useState();
    return (
        <IngressContext.Provider value={[ingress, set_ingress]}>
            {props.children}
        </IngressContext.Provider>
    )
}

export { IngressContext, IngressProvider };

